import { useGameState } from '@/pages/spatial-span-shinhan/hooks/useGameState';
import { useViewportMetrics } from '@/pages/spatial-span-shinhan/hooks/useViewportMetrics';
import ServiceIntro from '@/pages/spatial-span-shinhan/components/ServiceIntro';
import BrainWarmupScreen from '@/pages/spatial-span-shinhan/components/BrainWarmupScreen';
import GuideScreen from '@/pages/spatial-span-shinhan/components/GuideScreen';
import GameScreen from '@/pages/spatial-span-shinhan/components/GameScreen';
import ResultScreen from '@/pages/spatial-span-shinhan/components/ResultScreen';
import ExitConfirmModal from '@/pages/spatial-span-shinhan/components/ExitConfirmModal';
import TopBar from '@/pages/spatial-span-shinhan/components/TopBar';

// 신한 SOL 인앱용 순서 기억하기 (Spatial Span) 버전
// 플로우: 서비스 소개 → 두뇌풀기 안내 → 게임 소개 → 본게임 → 결과
// 게임 로직은 기존 Spatial Span과 동일하며, 화면 구성/Interaction 만 신한 SOL 스타일로 개편
export default function SpatialSpanShinhan() {
  const metrics = useViewportMetrics();

  const {
    screen,
    stage,
    showingIndex,
    isShowing,
    sequence,
    userSequence,
    isInputEnabled,
    message,
    score,
    maxSuccessSpan,
    layout,
    feedback,
    isFinalizing,
    isReplaying,
    replayIndex,
    stagePulse,
    stageText,
    showExitModal,
    startGame,
    goToGuide,
    goToWarmup,
    goToIntro,
    handleGameTilePress,
    goToNext,
    openExitModal,
    closeExitModal,
    confirmExit,
  } = useGameState();

  const isPlaying = screen === 'game';
  // 서비스 소개(진입) 화면에서는 상단바를 렌더링하지 않아 로고가 페이지 최상단에 붙는다
  const isEntry = screen === 'intro';
  // 결과 화면은 연파랑 그라데이션 배경을 사용한다 (상단바 영역까지 이어짐)
  const isResult = screen === 'result';

  // WebView 네비게이션과 충돌하지 않도록 게임 정보 없이 뒤로/홈만 배치
  const handleBack = () => {
    if (isPlaying) {
      openExitModal();
      return;
    }
    if (screen === 'warmup') {
      goToIntro();
      return;
    }
    if (screen === 'guide' || screen === 'result') {
      goToWarmup();
    }
  };

  const handleHome = () => {
    if (isPlaying) {
      openExitModal();
      return;
    }
    goToIntro();
  };

  return (
    <div className="shinhan-scope w-full bg-white flex justify-center">
      <div
        className={`w-full max-w-[430px] flex flex-col relative overflow-hidden game-no-scroll ${isResult ? 'sh-result-bg' : 'bg-white'}`}
        style={{ height: `${metrics.height}px` }}
      >
        {!isEntry && (
          <TopBar
            onBack={handleBack}
            onHome={handleHome}
            /* 게임 화면에서는 헤더부터 하단까지 BG 컬러 레이어가 이어져야 하고,
               결과 화면에서는 그라데이션 배경이 상단바 뒤로 이어지도록 투명 처리 */
            backgroundClassName={isPlaying ? 'sh-game-bg' : isResult ? 'bg-transparent' : 'bg-white'}
          />
        )}

        <div className="flex-1 min-h-0 overflow-hidden">
          {screen === 'intro' && <ServiceIntro onStart={goToWarmup} />}
          {screen === 'warmup' && <BrainWarmupScreen onNext={goToGuide} />}
          {screen === 'guide' && <GuideScreen onStart={startGame} />}
          {screen === 'game' && (
            <GameScreen
              stage={stage}
              layout={layout}
              sequence={sequence}
              showingIndex={showingIndex}
              isShowing={isShowing}
              onTilePress={handleGameTilePress}
              isInputEnabled={isInputEnabled}
              userSequence={userSequence}
              message={message}
              feedback={feedback}
              isFinalizing={isFinalizing}
              replayIndex={replayIndex}
              isReplaying={isReplaying}
              stagePulse={stagePulse}
              stageText={stageText}
            />
          )}
          {screen === 'result' && (
            <ResultScreen
              score={score}
              maxSuccessSpan={maxSuccessSpan}
              onRetry={startGame}
              onNext={goToNext}
            />
          )}
        </div>

        <ExitConfirmModal
          isOpen={showExitModal}
          onConfirm={confirmExit}
          onCancel={closeExitModal}
        />
      </div>
    </div>
  );
}